/**
 * Created by alex.shmaltsuev on 2016-05-08.
 */

import PropTypes from 'prop-types';

import React from 'react';
import Style from './widgetTab.scss';
import C_R from '../../constants/routes';
import StyledShowAllLink from '../utils/Styled/links';
import Cx from 'classnames';

/**
 *returns a react object of the widgetTab
 */
class WidgetTab extends React.Component {

    render() {
        const showAllString = this.props.intlObject['ssp.scoreboard.widget.show.all'];
        let link = <span>
                        <StyledShowAllLink to={C_R.SCOREBOARD_PATH}
                                           onClick={() => this.props.setActiveTab(
                                               this.props.tabName)} className={Style.showAll}>
                            {showAllString} <span
                            className={Cx('iconIssue', 'arrowRight', Style.arrowRight)}></span>
                        </StyledShowAllLink>
                </span>;
        return (
            <div>
                {this.props.listItems}
                {link}
                <div className="clearfix"></div>
            </div>
        )
    }
}

WidgetTab.propTypes = {
    tabName: PropTypes.string.isRequired,
    setActiveTab: PropTypes.func.isRequired,
    listItems: PropTypes.array.isRequired,
    intlObject: PropTypes.object.isRequired
};

export default WidgetTab;






// WEBPACK FOOTER //
// ./components/Scoreboard/widgetTab.js